export default __webpack_public_path__ + "static/media/a5.3c5c949f.png";